module.exports = __webpack_public_path__ + "cfd1cb8cfe64c5d642162399631bce39.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/gallery/n/n08.jpg
// module id = 666
// module chunks = 0